import { Injectable } from '@angular/core';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { OrderTextWithCatalogModel } from '../order-text-with-catalog.model';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

export type GetOrderListResponse = {
  OrderCode: string;
  CatalogID: string;
  RegistCycle: string;
}[];

/**
 * 受注(コード)リスト取得クラス
 *
 * @export GetOrderListService
 * @class GetOrderListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderListService extends PlessJsonResponderSub<GetOrderListResponse> {
  // 処理に使用するModel
  private model: OrderTextWithCatalogModel;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOrderListService
   */
  execute(
    model: OrderTextWithCatalogModel,
    successFunc: () => void = null
  ): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getOrderList', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderListService
   */
  success(data: GetOrderListResponse): void {
    this.model.updateOrderList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
